import api from './api';

/**
 * Service pour gérer les paiements FineoPay
 */

export interface PaymentResponse {
  success: boolean;
  message: string;
  data: {
    paymentUrl: string;
    orderId: number;
    amount: number;
  };
}

export interface OrderStatusResponse {
  success: boolean;
  data: {
    orderId: number;
    reference: string;
    paymentStatus: string;
    paymentMethod: string;
    amount: number;
    createdAt: string;
    updatedAt: string;
    quote: any;
  };
}

/**
 * Générer un lien de paiement FineoPay pour une commande
 */
export const generatePaymentLink = async (
  orderId: number,
  amount: number,
  title: string,
  description?: string
): Promise<PaymentResponse> => {
  try {
    const response = await api.post('/payments/fineopay/initialize', {
      orderId,
      amount,
      title,
      description: description || `Paiement pour ${title}`
    });
    return response.data;
  } catch (error: any) {
    console.error('❌ Erreur génération lien paiement:', error);
    throw error;
  }
};

/**
 * Vérifier le statut de paiement d'une commande
 */
export const checkOrderPaymentStatus = async (orderId: number): Promise<OrderStatusResponse> => {
  try {
    const response = await api.get(`/fineopay/order-status/${orderId}`);
    return response.data;
  } catch (error: any) {
    console.error('❌ Erreur vérification statut:', error);
    throw error;
  }
};

/**
 * Générer et ouvrir le lien de paiement dans une nouvelle fenêtre
 */
export const openPaymentCheckout = async (
  orderId: number,
  amount: number,
  reference: string
): Promise<string> => {
  try {
    const result = await generatePaymentLink(
      orderId,
      amount,
      `Commande ${reference}`,
      `Paiement pour la commande ${reference}`
    );

    if (result.success && result.data.paymentUrl) {
      // Ouvrir dans une nouvelle fenêtre
      window.open(result.data.paymentUrl, '_blank', 'width=800,height=600');
      return result.data.paymentUrl;
    }

    throw new Error('URL de paiement non disponible');
  } catch (error: any) {
    console.error('❌ Erreur ouverture checkout:', error);
    throw error;
  }
};

const fineoPayService = {
  generatePaymentLink,
  checkOrderPaymentStatus,
  openPaymentCheckout
};

export default fineoPayService;
